import { Theme } from 'react-select';
import { emphasize, makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const selectTheme = (theme: Theme): Theme => ({
  ...theme,
  borderRadius: 6,
  colors: {
    ...theme.colors,
    primary: '#9a9a9a',
    primary50: '#e0e0e0',
    primary25: '#e0e0e0',
  },
});

export const useStyles = makeStyles(theme => ({
  label: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '30px',
    color: '#000',
    paddingBottom: 5,
    display: 'flex',
  },
  root: {
    flexGrow: 1,
    height: 250,
  },
  container: {
    fontSize: 16,
    lineHeight: '24px',
    color: '#2D2D2D',
    padding: theme.spacing(10, 7.5),
    background: '#fff',
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: 1,
  },
  input: {
    display: 'flex',
    height: 'auto',
    color: '#2D2D2D',
    padding: '10px 28px 9px 15px',
    background: '#fff',
    border: `1px solid #ABAFB3`,
  },
  disabledInput: {
    background: theme.palette.grey[900],
    cursor: 'not-allowed',
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  valueContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    "& svg": {
      margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? '0 -6px 0 5px':  '0 5px 0 -6px',
    }
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(4, 8),
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    font: 'normal normal normal 14px/18px Roboto',
    color: '#C4C4C4',
    // position: 'absolute',
    left: theme.spacing(9),
  },
  paper: {
    borderRadius: 10,
    boxShadow: '0px 1px 14px #00000014',
    border: '1px solid #DDDFE1',
    padding: 0,
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(5.5),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
  indicatorWrapper: {
    '& > div': {
      padding: 0,
    },
  },
  clearIndicatorWrapper: {
    '& > div': {
      padding: 0,
      paddingRight: 20,
      cursor: 'pointer',
    },
  },
  manuItem: {
    padding: '17.5px 32px',
  },
}));
